<div class="main">
    <div class="dx-field-title" translate>alerts.pageTitle</div>
    <div class="dx-field selector">
        <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
        <div class="dx-field-value">
            <app-file-transfer-picker #fileTransferPicker [fileTransfers]="fileTransfers" (selectedItemChange)="filterChanged($event)"></app-file-transfer-picker>
        </div>
    </div>
    <br />
    <dx-data-grid #recipientsGrid
                  keyExpr="id"
                  id="tab-recipients"
                  [dataSource]="recipients"
                  height="calc(100vh - 215px)"
                  hoverStateEnabled="true"
                  [columnAutoWidth]="true"
                  (onContextMenuPreparing)="onContextMenuPreparing($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="displayName" [displayFormat]="'alerts.lblAlertsCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="showRecipientCreatePopup()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="save" [text]="'alerts.lblSaveChanges' | translate" (onClick)="updateRecipients()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadData()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="displayName" [caption]="'_commons.recipient' | translate" [calculateCellValue]="displayRecipientName"></dxi-column>
        <dxi-column [width]="100" cellTemplate="isGroupCellTemplate" [caption]="'_commons.group' | translate"></dxi-column>
        <!-- File transfer log types -->
        <dxi-column [caption]="'alerts.lblFileTransfersLogAlerts' | translate">
            <dxi-column [width]="100"
                        dataField="TransferSucceeded"
                        cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblTransferSucceeded' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="TransferFailed" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblTransferFailed' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="ACKKOFileReceived" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblAckKoFileReceived' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="ACKOKFileReceived" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblAckOkFileReceived' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="NoACKReceived" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblNoAckReceived' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="FileAlreadyExistsInTarget" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblFileAlreadyExistsInTarget' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="ArchivedFileSentByEmail" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblArchivedFileSentByEmail' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="EmptyFileIgnored" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblEmptyFileIgnored' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="RealTimeDisconnected" cellTemplate="enumCellFileTransferLogTemplate"
                        [caption]="'alerts.lblRealTimeDisconnected' | translate"></dxi-column>
        </dxi-column>
        <!-- Remote platform log types -->
        <dxi-column [caption]="'alerts.lblRemotePlatformsLogAlerts' | translate">
            <dxi-column [width]="100" dataField="CredentialsError" cellTemplate="enumCellRemotePlatformLogTemplate"
                        [caption]="'alerts.lblCredentialsError' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="TechnicalError" cellTemplate="enumCellRemotePlatformLogTemplate"
                        [caption]="'alerts.lblTechnicalError' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="InvalidPublicKey" cellTemplate="enumCellRemotePlatformLogTemplate"
                        [caption]="'alerts.lblInvalidPublicKey' | translate"></dxi-column>
            <dxi-column [width]="100" dataField="InvalidCertificate" cellTemplate="enumCellRemotePlatformLogTemplate"
                        [caption]="'alerts.lblInvalidCertificate' | translate"></dxi-column>
        </dxi-column>

        <!-- Custom cell templates -->
        <div *dxTemplate="let cell of 'isGroupCellTemplate'">
            <dx-check-box [value]="cell.data.notificationGroupName ? true : false" [readOnly]="true"></dx-check-box>
        </div>
        <div *dxTemplate="let cell of 'enumCellFileTransferLogTemplate'">
            <dx-check-box [value]="cell.data.fileTransferLogTypesEnums.indexOf(cell.column.dataField) > -1"
                          (onValueChanged)="setRecipientFileTransferLogValue(cell.data, cell.column.dataField, $event)">
            </dx-check-box>
        </div>
        <div *dxTemplate="let cell of 'enumCellRemotePlatformLogTemplate'">
            <dx-check-box [value]="cell.data.remotePlatformLogTypesEnums.indexOf(cell.column.dataField) > -1"
                          (onValueChanged)="setRecipientRemotePlatformLogValue(cell.data, cell.column.dataField, $event)">
            </dx-check-box>
        </div>
    </dx-data-grid>
</div>

<!-- RECIPIENT POPUPS -->
<dx-popup [title]="'alerts.lblRecipientCreate' | translate" [(visible)]="createRecipientVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="createRecipientVisible">
            <dx-validation-group #recipientValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.email<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="newRecipientData.userId || newRecipientData.notificationGroupId"
                            [(value)]="newRecipientData.emailAddress">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                    type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                    type="email" [message]="'alerts.valInvalidEmail' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.employee<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <app-employee-picker [readOnly]="newRecipientData.emailAddress || newRecipientData.notificationGroupId"
                            [isRequired]="!newRecipientData.emailAddress && !newRecipientData.notificationGroupId"
                            (selectedItemChange)="newRecipientData.userId = $event.id" (selectionCleared)="newRecipientData.userId = null">
                        </app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.group<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-select-box [dataSource]="groups" displayExpr="name" [readOnly]="newRecipientData.emailAddress || newRecipientData.userId"
                            [showClearButton]="true" (onSelectionChanged)="newRecipientData.notificationGroupId = $event.selectedItem ? $event.selectedItem.id : null">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.emailAddress"
                                    type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <hr /><br />
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblFileTransfersLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="fileTransferLogTypes" [displayExpr]="displayFileTransferLogType" [showClearButton]="true"
                            [showSelectionControls]="true" [(selectedItems)]="newRecipientData.fileTransferLogTypesEnums"
                            (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblRemotePlatformsLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="remotePlatformLogTypes" [displayExpr]="displayRemotePlatformLogType" [showClearButton]="true"
                            [showSelectionControls]="true" [(selectedItems)]="newRecipientData.remotePlatformLogTypesEnums"
                            (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createRecipient()"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="createRecipientVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
